import { toTitleCase } from "../../../../Utils/stringUtls";
import { disputeProcessing } from "../../OptionalFeatures/ChargebackAndDispute";
const ChargeBackAndDisputeOverview = ({ data }) => {
  const {
    of_cdp_processor,
    of_cdp_company_name,
    of_cdp_contact_name,
    of_cdp_job_title,
    of_cdp_phone_number,
    of_cdp_country,
    of_cdp_email,
  } = data["6_1"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">
            Chargeback & Dispute Processing
          </div>
          <div>{disputeProcessing[of_cdp_processor]?.label ?? "-"}</div>
        </div>
        {of_cdp_processor === 2 && (
          <>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Name</div>
              <div className="overview-val-text">
                {of_cdp_company_name?.length
                  ? toTitleCase(of_cdp_company_name)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Contact Name</div>
              <div className="overview-val-text">
                {of_cdp_contact_name?.length
                  ? toTitleCase(of_cdp_contact_name)
                  : "-"}
              </div>
            </div>

            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold"> Job Title</div>
              <div className="overview-val-text">
                {of_cdp_job_title?.length ? toTitleCase(of_cdp_job_title) : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Phone</div>
              <div className="overview-val-text">
                {of_cdp_phone_number?.length
                  ? toTitleCase(of_cdp_phone_number)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Email</div>
              <div className="overview-val-text">
                {of_cdp_email?.length ? toTitleCase(of_cdp_email) : "-"}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default ChargeBackAndDisputeOverview;
